<template>
  <div class="row">
    <div class="col-12" style="text-align: right; padding: 10px">
      <q-btn-group outline >
        <c-btn
          v-if="editable"
          :url="saveUrl"
          :isSubmit="isSave"
          :param="ghsResult"
          mappingType="PUT"
          label="저장"
          icon="save"
          @beforeAction="saveInfo"
          @btnCallback="saveCallback" />
      </q-btn-group>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <c-card title="유해위험성" class="cardClassDetailForm" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="col-12 ghsinfodetail">
            <c-textarea
              :editable="editable"
              :rows="2"
              name="classficationResult"
              v-model="ghsResult.classficationResult">
            </c-textarea>
          </div>
        </template>
      </c-card>
      <c-card title="신호어" class="cardClassDetailForm" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="col-12 ghsinfodetail">
            <c-textarea
              :editable="editable"
              :rows="2"
              name="sign"
              v-model="ghsResult.sign">
            </c-textarea>
          </div>
        </template>
      </c-card>
      <c-card title="그림문자" class="cardClassDetailForm picCard" topClass="topcolor-orange">
        <template slot="card-detail">
          <q-intersection
            v-for="(item, index) in ghsResult.pics"
            :key="index"
            class="example-item"
            style="display:inline-table;"
          >
            <template v-if="item.pic !== '해당없음'">
              <img :src="require('@/assets/images/' + item.pic + '.gif')"
                :style="{ width: '50px', }">
              <q-checkbox v-model="item.chk" 
                color="red"
                true-value="Y"
                false-value="N" />
            </template>
          </q-intersection>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <c-card title="예방조치문구" class="cardClassDetailForm" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="col-12 ghsinfodetail">
            <c-textarea
              :editable="editable"
              :rows="2"
              name="sign"
              v-model="ghsResult.pcodeResult">
            </c-textarea>
          </div>
        </template>
      </c-card>
      <c-card title="유해·위험문구" class="cardClassDetailForm" topClass="topcolor-orange">
        <template slot="card-detail">
          <div class="col-12 ghsinfodetail">
            <c-textarea
              :editable="editable"
              :rows="2"
              name="sign"
              v-model="ghsResult.hcodeResult">
            </c-textarea>
          </div>
        </template>
      </c-card>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'chem-ghs-2',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        plantCd: '',
        plantName: '',
        materialCd: '',
        materialName: '',
        productCategoryCd: '',
        isSaved: '',
        updateFlag: '',
      }),
    },
  },
  data() {
    return {
      ghsResult: {
        classficationResult: '',
        pics: [],
        sign: '',
        pcodeResult: '',
        hcodeResult: '',
        regUserId: '',
        chgUserId: '',
      },
      editable: true,
      isSave: false,
      listUrl: '',
      saveUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.ghs.mix.list;
      this.saveUrl = transactionConfig.mdm.ghs.mix.save;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {mdmChemMaterialId: this.param.mdmChemMaterialId};
      this.$http.request((_result) => {
        this.$_.extend(this.ghsResult, _result.data)
      },);
    },
    saveInfo() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.ghsResult.regUserId = this.$store.getters.user.userId;
          this.ghsResult.chgUserId = this.$store.getters.user.userId;

          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
    },
  }
};
</script>

<style lang="sass">
  .ghsinfodetail
    padding-bottom:10px !important
    margin-top:-20px
  .picCard
    .customCardbody 
      padding: 10px !important
      margin: 0 !important
</style>